import { Game } from "onearm";
import { GameConfig } from "./configs/GameConfig.js";

(async () => {
    try {
        if (typeof window !== "undefined") {
            // Если index.html устарел и `__SKINS__` не инжектирован — стартуем
            // хотя бы с default'ом, иначе движок упадёт на `manifest.bundles`.
            if (!Array.isArray(window.__SKINS__)) {
                window.__SKINS__ = ["default"];
            }
            // Если в URL запрошен скин (?s=foo), которого нет в списке —
            // добавляем его, чтобы движок попытался зафетчить его manifest.json
            // напрямую. Если файла нет — сработает встроенный fallback на default.
            const params = new URLSearchParams(location.search);
            const requested = (params.get("s") || params.get("skin") || "").trim();
            if (requested && !window.__SKINS__.includes(requested)) {
                window.__SKINS__.push(requested);
            }
        }
        Game.start(GameConfig);
    } catch (err) {
        console.error("[boot] fatal:", err);
        if (typeof window !== "undefined" && window.__bootSplashError) {
            window.__bootSplashError(err?.message || "Failed to start game.");
        }
    }
})();
